export const API_URL = process.env.REACT_APP_API_ENDPOINT
export const MAPBOX_API = process.env.REACT_APP_MAPBOX
export const APPLICATION_STORE = "application-store"
